/*
 *		Copyright (c) 2011-2023 Acronis Incorporated. All rights reserved.
 *
 *	This source code may be used only by organizations licensed to use Acronis Access, in conjunction with normal Acronis Access usage.
 *	No portion of it may be redistributed or modified without the written permission of Acronis, Inc. See the Acronis Software License Agreement for more information.
 */

angular.module('accessWebClient')
    .controller('ShareGroupsAddMembersModalController', [
        '$modalInstance',
        '$scope',
        '$translate',
        'flashMessagesService',
        'ShareGroupsMembersResource',
        function (
            $modalInstance,
            $scope,
            $translate,
            flashMessagesService,
            ShareGroupsMembersResource
        ) {
            let haveMembersChanged = false;
            $scope.modal = $modalInstance.options;
            $scope.close = $scope.cancel = () => haveMembersChanged ? $modalInstance.close() : $modalInstance.dismiss();
            $scope.emails = [];

            $scope.onMembersUpdate = (emails) => {
                $scope.emails = angular.isArray(emails) ?
                    emails.map((email) =>
                        angular.isString(email) ?
                            { label: email, value: email } :
                            email
                    ) :
                    [];
            };

            $scope.addMembers = async () => {
                $scope.modal.loading = true;

                const promises = $scope.emails
                    .filter(({ value: email }, index, emails) => emails.findLastIndex(({ value: e }) => e === email) === index)
                    .map(({ value: email }) => ShareGroupsMembersResource.save({
                        uuid: $scope.shareGroup.uuid,
                        email: email
                    }).$promise);

                const responses = await Promise.allSettled(promises);

                // Checks if all promises are resolved
                if (responses.every(({ status }) => status === 'fulfilled')) {
                    $modalInstance.close();
                    return;
                }

                // Checks if there is a mix of resolved and rejected promises
                if (!responses.every(({ status }) => status === 'rejected')) {
                    haveMembersChanged = true;
                }

                flashMessagesService.add(
                    $translate.instant('share_groups_add_members_fail_flash_message'),
                    flashMessagesService.ERROR
                );

                $scope.modal.loading = false;
                $scope.$digest();
            };
        }
    ]);
